import {
  DirectDebitValidationRequest,
  DirectDebitValidationResponse,
} from '@dgx-pr-spa/shared/util';
import { ActionError } from '@dgx-pr-spa/shared/util';
import { createAction, props } from '@ngrx/store';

export const loadDirectDebitValidation = createAction(
  '[Complete Order] Load Direct Debit Validation',
  props<{ payload: DirectDebitValidationRequest }>()
);

export const loadDirectDebitValidationSuccess = createAction(
  '[Complete Order] Load Direct Debit Validation Success',
  props<{ payload: DirectDebitValidationResponse }>()
);

export const loadDirectDebitValidationFail = createAction(
  '[Complete Order] Load Direct Debit Validation Fail',
  props<{ payload: ActionError }>()
);

export const resetDirectDebitValidation = createAction(
  '[Complete Order] Reset Direct Debit Validation'
);

export type DirectDebitValidationActions =
  | typeof loadDirectDebitValidation
  | typeof loadDirectDebitValidationSuccess
  | typeof loadDirectDebitValidationFail
  | typeof resetDirectDebitValidation;
